module.exports = __webpack_public_path__ + "static/img/viral_21.b91df1d8.jpg";